import dayjs from "dayjs"

const _now = dayjs()
export const oneWeekAgo = _now.subtract(7, "days").format("YYYY-MM-DDTHH:mm:ss")
export const now = dayjs().format("YYYY-MM-DDTHH:mm:ss")

export const today = dayjs().format("YYYY-MM-DD")
export const yesterday = _now.subtract(1, "days").format("YYYY-MM-DD")

export const weeks = (() => {
  let list = []
  for (let i = 1; i <= 6; i++) {
    list.push(_now.subtract(i, "days").format("YYYY-MM-DD"))
  }
  return list
})()

const currentDate = new Date()

// 저번달
const lastMonth = new Date(
  currentDate.getFullYear(),
  currentDate.getMonth() - 1
)
export const lastMonthFormatted = `${lastMonth
  .getFullYear()
  .toString()
  .slice(-2)}년 ${lastMonth.getMonth() + 1}월`

export const lastMonthFormatted2 = `${lastMonth.getFullYear().toString()}.${
  lastMonth.getMonth() + 1
}`

// 전년도 저번달
const lastYearLastMonth = new Date(
  currentDate.getFullYear() - 1,
  currentDate.getMonth() - 1
)
export const lastYearLastMonthFormatted = `${lastYearLastMonth
  .getFullYear()
  .toString()
  .slice(-2)}년 ${lastYearLastMonth.getMonth() + 1}월`
